<template>
  <div class="animated fadeIn">
    <b-alert show dismissible>
      Please note: This page is Work in Progress.
    </b-alert>

    <!-- HERO -->


      <b-card >
        <h1>
          Text Area
        </h1>
        <hr class="my-4">
        <p class="sub-headline">
          Create multi-line text inputs with support for auto height sizing, minimum and maximum number of rows, and contextual states.
        </p>
        

      </b-card>

    <!-- HERO END -->

  <b-card>
    <div>
    <b-form-textarea
      id="textarea"
      v-model="text"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
    ></b-form-textarea>

    <pre class="mt-3 mb-0">{{ text }}</pre>
    </div>
  </b-card>

  <b-card>
    <b-container fluid>
      <b-row>
        <b-col sm="2">
          <label for="textarea-small">Small:</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea
            id="textarea-small"
            size="sm"
            placeholder="Small textarea"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-default">Default:</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea
            id="textarea-default"
            placeholder="Default textarea"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-large">Large:</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea
            id="textarea-large"
            size="lg"
            placeholder="Large textarea"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-container>
  </b-card>

  <b-card>
    <h1>Showing Row</h1>
    <div>
      <b-form-textarea
        id="textarea-rows"
        placeholder="Tall textarea"
        rows="8"
      ></b-form-textarea>
    </div>
  </b-card>

  </div>
  
</template>

<script>
export default {
  name: 'textarea',
  data () {
    return {
      selected: [], // Must be an array reference!
      show: true
    }
  },
  methods: {
    click () {
      // do nothing
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
